export default __webpack_public_path__ + "static/media/android_en_pwa.eec4af39.png";